export enum FundCategoryCode {
  Equity = 'Eq',
  Us = 'Us',
  Large = 'Lrg',
  Mid = 'Mid',
  Small = 'Sm',
  Global = 'Global',
  NonUS = 'NonUs',
  Developed = 'Dev',
  Emerging = 'Emrg',
  MultiSector = 'MultiSector',
  InternationalGlobal = 'Intl',
  International = 'Intl',
  Dividend = 'Div',
  FixedIncome = 'Fi',
  StableValue = 'Stb',
  TreasuryAgency = 'Ta',
  InvGradeCorp = 'InvGrd',
  BelowInvGrade = 'BInvGrd',
  Muni = 'Muni',
  Short = 'Sh',
  Intermediate = 'Intmdt',
  Long = 'Lng',
  TargetDate = 'TgtDt',
  USBalanced = 'UsBal',
  TargetAllocation = 'TgtAlloc',
  CashEquivalent = 'CashEqv',
  Taxable = 'Taxable',
  SectorSpeciality = 'SectSpl',
  Sector = 'Sector',
  MultiAsset = 'MulAsset',
  ESGStrategy = 'Esg',
  FactorDrivenStrategy = 'FactorDriven',
  Index = 'Index',
  Blend = 'Blend',
  Growth = 'Growth',
  Value = 'Value',
  Balanced = 'Bal',
  Active = 'Active',
  //category level 3 - added to fix the issue with the common fund across the multiple category
  productType = 'productType',
  assetClass = 'assetClass',
  strategy = 'strategy',
  mgmtStyle = 'mgmtStyle',
  region = 'region',
  market = 'market',
  style = 'style',
  size = 'size',
  category = 'category',
  creditQuality = 'creditQuality',
  duration = 'duration',
}
